export default __webpack_public_path__ + "static/media/beforeribboncut_w640.5c892085.jpeg";